import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { AsideSticky, Main, Page, Content } from '../../components/Page';
import { FixedHeader } from '../FixedHeader';
import { Responsive, UiKitRoot } from '@cian/ui-kit';
import { AsideSection } from '../../components/AsideSection/AsideSection';
import { BreadCrumbs } from '../BreadCrumbs';
import { PriceBlock } from '../PriceBlock';
import { SeoLinksContainer } from '../SeoLinks/SeoLinksContainer';
import { PageTitleContainer } from '../PageTitle/PageTitle';
import { DescriptionContainer } from '../Description';
import { MortgageSectionContainer } from '../MortgageSection';
import { PromoDetailsContainer } from '../PromoDetails';
import { BuilderInfo } from '../BuilderInfo';
import { SpecificationsContainer } from '../Specifications';
import { PromosContainer } from '../Promos';
import { BuildersContainer } from '../BuildersMobile';

import { StickyBottomLayout } from '../../components/StickyBottomLayout';
import { CallToActionContainer } from '../MobileCall';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <Page>
              <FixedHeader />
              <BreadCrumbs />
              <Content>
                <Main>
                  <Responsive desktop>
                    <SeoLinksContainer />
                  </Responsive>
                  <PageTitleContainer />
                  <DescriptionContainer />
                  <Responsive tablet phone>
                    <PromosContainer />
                  </Responsive>
                  <Responsive desktop>
                    <MortgageSectionContainer />
                  </Responsive>
                  <SpecificationsContainer />
                  <Responsive tablet phone>
                    <SeoLinksContainer />
                  </Responsive>
                  <Responsive tablet phone>
                    <BuildersContainer />
                  </Responsive>
                </Main>
                <AsideSticky>
                  <AsideSection>
                    <PriceBlock />
                  </AsideSection>
                  <AsideSection>
                    <BuilderInfo />
                  </AsideSection>
                </AsideSticky>
              </Content>
            </Page>
            <Responsive tablet phone>
              <StickyBottomLayout>
                <CallToActionContainer />
              </StickyBottomLayout>
            </Responsive>
            <PromoDetailsContainer />
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
